import * as React from 'react'

import IncidentListScreen from '@screens/incident/IncidentListScreen'

import * as FiltreStore from '@store/filtre/filtre'

interface Props {
  onBack?: () => void
}

const MapScreen = (props: Props) => {
  React.useEffect(() => {
    // always in map mode
    FiltreStore.actions.setIncidentFilter({ isMap: true })
  }, [])

  return <IncidentListScreen {...props} />
}

export default MapScreen
